var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPreviewIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 25,
    viewBox: "0 0 17 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3542 11.4424L4.5441 3.89841C3.71691 3.2623 3.30332 2.94425 2.9564 2.94853C2.65457 2.95226 2.37058 3.09213 2.18363 3.32911C1.96875 3.60151 1.96875 4.12326 1.96875 5.16675V20.5826C1.96875 21.6501 1.96875 22.1838 2.18748 22.4576C2.37771 22.6957 2.66612 22.834 2.97087 22.8334C3.32129 22.8326 3.73756 22.4986 4.57011 21.8306L14.3802 13.9586C14.9221 13.5238 15.193 13.3064 15.2889 13.0451C15.3729 12.816 15.3703 12.5642 15.2816 12.3369C15.1803 12.0776 14.9049 11.8659 14.3542 11.4424Z",
    stroke: "#FFFFFE",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewIcon);
export default __webpack_public_path__ + "static/media/PreviewIcon.2e99538db1d4af7779835d3d9404618e.svg";
export { ForwardRef as ReactComponent };